import { useState, useEffect } from "react";
import { utils, image, productUtil } from '@/utils'
import Thumb from '@/components/Thumb'
import type {
  ProductItem as IProductItem,
  ProductDetail,
} from '@/types/product'
import styles from './index.module.less'

interface IProps {
  className: string;
  productData: IProductItem
}
const FailProductItem = (props: IProps) => {
  const { productData } = props
  const saleProduct = productData.saleProduct || {}
  const cloudProduct = productData.cloudProduct || {}
  const { productStatus } = cloudProduct
  const isMultiple = (productStatus & 4) === 4 // 是否是多规格数据
  const details: ProductDetail[] = saleProduct.details || []
  const { to } = utils
  const { imgFormatter } = image
  const [thumbInfo, setThumbInfo] = useState({
    url: '',
  })
  let lastImgUrl = ''

  useEffect(() => {
    initThumb()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productData.cloudProduct])

  // 初始化缩略图
  async function initThumb() {
    // 有图时拿首图
    const { imageList, video } = cloudProduct || {}
    const imgUrl = (imageList && imageList[0]) || video || ''

    if (imgUrl === lastImgUrl) {
      return
    }

    const [err, res] = await to(imgFormatter(imgUrl, 260))

    lastImgUrl = imgUrl
    setThumbInfo({
      url:  err ? imgUrl : res
    })
  }

  return (
    <div className={ styles["product-wrap"] }>
      {/* 商品图片 */}
      <Thumb
        extClass={ styles["product-thumb"] }
        width={ 164 }
        height={ 164 }
        thumb={ thumbInfo }
        isInvalid={ true }
        has-video={ !!cloudProduct?.video } 
      />

      <div className={ styles["product-content"] }>
        {/* 商品标题行 */}
        <div className={ `${styles["product-title"]} ep-2` }>
          {
            cloudProduct?.highlight &&
            <div dangerouslySetInnerHTML={ cloudProduct?.highlight }></div>
          }
          {
            !cloudProduct?.highlight &&
              <>
                {/* 商品标签 */}
                <span className={ productUtil.getRecommendClass(cloudProduct) }>
                  { productUtil.getRecommendTag(cloudProduct) }
                </span>
                {/* 商品标题 */}
                <span>{ cloudProduct?.productName || '' }</span>
              </>
          }
        </div>

        {
          isMultiple && (
            !!details.length && details.map(detail => {
              const { elements } = detail
              const elementNames = elements.map(ele => ele.elementName).join('，')
              return <div className={ styles["product-spec"] }>
                { elementNames }
              </div>
            })
          )
        }
      </div>
    </div>
  )
}

export default FailProductItem
